<template lang="pug">
div.wrap-atom-bone-joint-picker
  //- div(v-for="item in bones"
    @click="onJoint(item)"
    :class="`joint-${item.name} ${(selectedJoint && selectedJoint.name == item.name) ? 'active' : ''}`").joint.cursor-pointer
  div(v-for="joint in bones"
    @click="onJoint(joint)"
    :class="`joint-${joint.name} ${(selectedJoint && selectedJoint.name == joint.name) ? 'active' : ''} ${(mirrorJointName && mirrorJointName == joint.name) ? 'active-mirror' : ''}`").joint.cursor-pointer
  v-img(src="/img/icon/humanoid.svg")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$joint_size: 12px;
.wrap-atom-bone-joint-picker {
  position: relative;
  width: 240px;
  height: 240px;
  .joint {
    position: absolute;
    width: $joint_size; height: $joint_size;
    border-radius: 100%;
    z-index: 1;
    background: $secondary_bg_color;
    &.active {
      background: $active_color;
    }
    &.active-mirror {
      background: $active_color;
      opacity: 0.3;
    }
    // offsetで中央に整列
    margin-left: calc(-#{$joint_size} / 2 + 50%); margin-top: calc(-#{$joint_size} / 2 + 50%);
  }
  .joint-Head {
    top: -40%;
  }
  .joint-LeftEye {
    top: -40%; left: 6%;
  }
  .joint-RightEye {
    top: -40%; left: -6%;
  }
  .joint-Neck {
    top: -30%;
  }
  .joint-Chest {
    top: -16%;
  }
  .joint-Spine {
    top: -6%;
  }
  .joint-Hips {
    top: 8%;
  }

  .joint-RightUpperLeg {
    top: 13%; left: -9%;
  }
  .joint-RightLowerLeg {
    top: 30%; left: -9%;
  }
  .joint-RightFoot {
    top: 47%; left: -9%;
  }
  .joint-RightToes {
    top: 47%; left: -18%;
  }
  
  .joint-LeftUpperLeg {
    top: 13%; left: 9%;
  }
  .joint-LeftLowerLeg {
    top: 30%; left: 9%;
  }
  .joint-LeftFoot {
    top: 47%; left: 9%;
  }
  .joint-LeftToes {
    top: 47%; left: 18%;
  }

  .joint-RightShoulder {
    top: -20%; left: -7%;
  }
  .joint-RightUpperArm {
    top: -17%; left: -13%;
  }
  .joint-RightLowerArm {
    top: -7%; left: -24%;
  }
  .joint-RightHand {
    top: 1%; left: -32%;
  }

  .joint-LeftShoulder {
    top: -20%; left: 7%;
  }
  .joint-LeftUpperArm {
    top: -17%; left: 13%;
  }
  .joint-LeftLowerArm {
    top: -7%; left: 24%;
  }
  .joint-LeftHand {
    top: 1%; left: 32%;
  }
}
</style>

<script>
import { bones } from '@/plugins/vrm-nums'

export default {
  props: {
    currentJoint: {
      type: Object,
      default: null
    },
    isMirrorinig: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      selectedJoint: null, mirrorJointName: null
    }
  },
  computed: {
    bones () {
      return bones.filter(bone => {
        return !['LeftEye', 'RightEye'].includes(bone.name)
      })
    }
  },
  watch: {
    isMirrorinig () {
      if (this.isMirrorinig) {
        if (this.selectedJoint.mirrorJoint) this.mirrorJointName = this.selectedJoint.mirrorJoint
      } else {
        this.mirrorJointName = null
      }
    }
  },
  mounted () {
    if (this.currentJoint) {
      this.selectedJoint = { label: this.currentJoint.label, name: this.currentJoint.name }
    } else {
      this.selectedJoint = { label: '頭', name: 'Head' }
    }
    // if (!this.selectedJoint) this.selectedJoint = { label: '頭', name: 'Head' }
  },
  methods: {
    onJoint (joint) {
      this.selectedJoint = joint
      if (this.isMirrorinig) this.mirrorJointName = joint.mirrorJoint ? joint.mirrorJoint : null
      this.$emit('setCurrentJoint', joint)
    },
    async getJointClass (joint) {
      return `
        joint-${joint.name}
        ${(this.selectedJoint && this.selectedJoint.name == joint.name) ? 'active' : ''}
        ${(this.mirrorJointName && this.mirrorJointName == joint.name) ? 'active-mirror' : ''}
        `
    }
  }
}
</script>
